import {
  type ClientV3,
  type InstrumentBarChartData,
  type TradingGraphs,
} from "../../../api/generated";
import {
  createReportContext,
  type InferReport,
} from "../../../context/ReportContext";

const tradingReport = createReportContext({
  rebateAccountIDs: "multi",
  rebateProgramIDs: "multi",
  clientTypes: "multi",
  subIBIDs: "multi",
})<
  {
    rebateAccountIDs: string;
    rebateProgramIDs: string;
    clientTypes: string;
    subIBIDs: string;
  },
  {
    table: {
      tradingList: ClientV3[];
      totalCount: number;
      redactedFields: string[];
    };
    graphs: {
      graph: TradingGraphs;
      instrument: InstrumentBarChartData[];
    };
    csv: void;
  },
  {
    startDate: string;
    endDate: string;
    selected: {
      rebateAccountIDs: string[] | null;
      rebateProgramIDs: string[] | null;
      clientTypes: string[] | null;
      subIBIDs: string[] | null;
    };
    search: string;
    page: number;
    pageSize: number;
    sortColumn: string | null;
    sortDesc: boolean | null;
    clientType: "direct" | "indirect" | null;
  }
>();

export const {
  Provider: ClientTradingReportContextProvider,
  useReportContext: useClientTradingReportContext,
} = tradingReport;

export type TradingReportParams = InferReport<typeof tradingReport, "params">;
export type TradingReportStates = InferReport<typeof tradingReport, "states">;
